module.exports = __webpack_public_path__ + "76dcebc0735f58b00e16a3b0aa5e43bd.jpg";